import {AppBar as MuiAppBar, Box, IconButton as MuiIconButton, Link, Stack, styled, Toolbar, Tooltip, Typography} from '@mui/material';
import {useAuth} from "../auth/AuthProvider";
import {AccountCircle, Help, Logout} from "@mui/icons-material";
import {useLocation, useNavigate} from "react-router";
import useMediaQuery from '@mui/material/useMediaQuery';
import HeaderMenu from "./HeaderMenu";

const AppBar = styled(MuiAppBar)(({theme}) => ({
    backgroundColor: theme.palette.background.paper,
}));

const Title = styled(Typography)(({theme}) => ({
    fontWeight: 'bold',
    color: theme.palette.admin.main,
    [theme.breakpoints.up('xs')]: {
        fontSize: theme.typography.h5.fontSize,
    },
    [theme.breakpoints.up('md')]: {
        fontSize: theme.typography.h3.fontSize,
    }
}));

const IconButton = styled(MuiIconButton)(({theme}) => ({
    color: theme.palette.payLevels.main,
    "&:hover": {
        color: theme.palette.admin.main,
    }
}));

const Header = () => {
    const {user, signOut} = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const isMediumView = useMediaQuery((theme) => theme.breakpoints.up('md'));

    const handleLogout = () => {
        signOut();
    };

    const isPayLevelsPage = location.pathname === "/levels";
    const isPayAwardsPage = location.pathname === "/awards";

    const imageWidth = isMediumView ? 149 : 75;

    return (
        <AppBar position="static" elevation={0}>
            <Toolbar>
                <Stack direction="row" spacing={{xs: 2, md: 5}} alignItems="center">
                    <Link href="https://incomesdataresearch.co.uk" sx={{paddingTop: "4px"}}>
                        <img alt="Incomes Data Research" src="/assets/images/logo.svg?v=2.0.6" height="auto" width={imageWidth}/>
                    </Link>
                    <Link href="/" underline="none">
                        <Title>Pay Benchmarker</Title>
                    </Link>
                </Stack>
                <Box sx={{flexGrow: 1}}>
                    <Stack direction="row" spacing={1} sx={{justifyContent: "right"}}>
                        {user && (
                            <>
                                {isMediumView ? (
                                    <Box>
                                        <Tooltip title="My Details">
                                            <IconButton id="my_details" name="my_details" size="large" onClick={() => navigate("/my_details")}>
                                                <AccountCircle fontSize="large"/>
                                            </IconButton>
                                        </Tooltip>
                                        {isPayLevelsPage && (
                                            <Tooltip title="Glossary">
                                                <IconButton id="help_levels" name="help_levels" tooltip="Glossary" onClick={() => navigate("/help/levels")}>
                                                    <Help fontSize="large"/>
                                                </IconButton>
                                            </Tooltip>
                                        )}
                                        {isPayAwardsPage && (
                                            <Tooltip title="Glossary">
                                                <IconButton id="help_awards" name="help_awards" tooltip="Glossary" onClick={() => navigate("/help/awards")}>
                                                    <Help fontSize="large"/>
                                                </IconButton>
                                            </Tooltip>
                                        )}
                                        {!isPayLevelsPage && !isPayAwardsPage && (
                                            <Tooltip title="Help">
                                                <IconButton id="site_help" name="site_help" tooltip="Help" onClick={() => navigate("/help")}>
                                                    <Help fontSize="large"/>
                                                </IconButton>
                                            </Tooltip>
                                        )}
                                        <Tooltip title={'Logout'}>
                                            <IconButton id="logout" name="logout" onClick={handleLogout}>
                                                <Logout fontSize="large"/>
                                            </IconButton>
                                        </Tooltip>
                                    </Box>
                                ) : (
                                    <HeaderMenu/>
                                )}
                            </>
                        )}
                    </Stack>
                </Box>
            </Toolbar>
        </AppBar>
    );
};

export default Header;
